
    var riot = require('riot')
    //src: starling/src/tags/presence-cursors.html
riot.tag2('presence-cursors',
  '<div each="{user in collaborators}" id="cursor-{user.id}" class="cursor-container hidden" riot-style="color: {colorFromUserId(user.id)};"> <svg class="cursor"> <use xlink:href="#cursor-icon"></use> </svg> <div class="display-name" riot-style="background-color: {colorFromUserId(user.id, 0.1)};"> {user.display_name} </div> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _util = require('lib/util');

var _collaboratorsUi = require('lib/collaborators-ui');

var _opts = opts,
    canvas = _opts.canvas,
    operation = _opts.operation;
var sender = operation.sender;

canvas.presenceCursors = this;

this.mouseMoved = {};
this.collaborators = {};
this.colorFromUserId = _util.colorFromUserId;

this.on('update', function () {
  _this.collaborators = canvas.presence.presence;
});

this.getCursor = function (userId) {
  return _this.root.querySelector('#cursor-' + userId);
};

this.presenceMoved = function (_ref) {
  var userId = _ref.userId,
      x = _ref.x,
      y = _ref.y;

  _this.update();

  var cursor = _this.getCursor(userId);

  if (cursor) {
    cursor.classList.remove('hidden');

    // if we lost the cursor in an element that was deleted, put our mouse cursor back
    if (!document.getElementById('input-field-cursor-' + userId)) {
      if (cursor.style.display === 'none') {
        cursor.style.display = '';
      }
    }
    Object.assign(cursor.style, {
      opacity: 1,
      top: y + 'px',
      left: x + 'px'
    });

    _this.mouseMoved[userId] = Date.now();
  }
};

this.disableStalePresences = function () {
  var now = Date.now();
  var mouseMoved = _this.mouseMoved;

  Object.keys(mouseMoved).forEach(function (id) {
    var lastSeen = now - mouseMoved[id];
    // ignore mouse movement if user's cursor is focused on a field
    if (_collaboratorsUi.cui.getCollaboratorFocus(id)) return;

    if (lastSeen > _constants.STALE_CURSOR_THRESOLD) {
      var cursor = _this.getCursor(id);

      if (cursor) {
        var style = cursor.style;

        if (!document.getElementById('input-field-cursor-' + id)) {
          if (style.display === 'none') {
            style.display = '';
          }
        }

        style.opacity = 0.4;

        if (style.display !== 'none' && lastSeen > _constants.HIDE_CURSOR_THRESOLD) {
          style.display = 'none';
          delete mouseMoved[id];
        }
      }
    }
  });
};

this.handleMouseMove = function (_ref2) {
  var clientX = _ref2.clientX,
      clientY = _ref2.clientY;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  if (operation.isLoggedOut()) return;

  sender.send({
    type: 'mouse_move',
    x: (clientX - tx) / scale,
    y: (clientY - ty) / scale
  });
};

canvas.on('mount', function () {
  sender.setHandler('mouse_move', _this.presenceMoved);
  setInterval(_this.disableStalePresences, 2000);
  canvas.refs.canvas.addEventListener('mousemove', _this.handleMouseMove);
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('presence-cursors')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/presence-cursors.html
// module id = 778
// module chunks = 0